import { Component } from '@angular/core';

@Component({
    selector: 'wci-intro',
    imports: [],
    templateUrl: './intro.component.html',
    styles: ``,
})
export class IntroComponent {}
